const Views = {
  OME_MEET_INFO_TEAM_ENTRY: 'Meet Info',
  OME_MEET_INFO_CONTACTS: 'Entry Contact',
  OME_MEET_ROSTER_ENTRIES: 'Roster Entries',
  OME_MEET_ROSTER_SELECTION: 'Roster Selection',
  OME_MEET_ROSTER_ENTRIES_DETAIL: 'Manage Athlete Events',
  OME_MEET_ROSTER_ENTRIES_INDIVIDUAL_SELECTION: 'Individual Event Selection',
  OME_MEET_ROSTER_ENTRIES_INDIVIDUAL_OVERRIDE: 'Individual Event Entry Override Time',
  OME_MEET_ROSTER_ENTRIES_BONUS_INDIVIDUAL_SELECTION: 'Individual Bonus Event Selection',
  OME_MEET_ROSTER_ENTRIES_BONUS_INDIVIDUAL_OVERRIDE: 'Individual Bonus Event Entry Override Time',
  OME_MEET_RELAY_ENTRIES: 'Relay Entries',
  OME_MEET_MANAGE_RELAY_TEAMS: 'Manage Relay Teams',
  OME_MEET_MANAGE_RELAY_TEAM: 'Manage Relay Team',
  OME_MEET_MANAGE_RELAY_TEAM_OVERRIDE: 'Add Relay Event Entry Override Time',
  OME_MEET_CREDENTIALS: 'Credentials',
  OME_MEET_CREDENTIALS_SELECTION: 'Credentials Selection',
  OME_MEET_ENTRY_REPORTS: 'Entry Reports',
  OME_MEET_SUBMIT: 'Submit',
  OME_MEET_SUBMITTED: 'Submitted'
};

const VIEW_DATA = [
  {
    name: Views.OME_MEET_INFO_TEAM_ENTRY,
    subHeaderText: 'Meet Info',
    instructionText: 'Determine Roster Permissions and Provide at least one Entry Contact.',
    nextButtonText: 'Continue',
    backButtonText: 'Exit',
    saveAndExitButtonText: 'Save & Exit'
  },
  {
    name: Views.OME_MEET_INFO_CONTACTS,
    subHeaderText: 'Entry Contact',
    instructionText: 'Provide an Entry Contact.',
    nextButtonText: 'Save',
    backButtonText: 'Back'
  },
  {
    name: Views.OME_MEET_ROSTER_ENTRIES,
    subHeaderText: 'Roster Entries',
    instructionText: "Add at least one Athlete to the Roster. All Athletes on the Roster must have a Status of 'Events Approved' or 'Relay Only Swimmer' (if Relay Only Swimmers are Allowed).",
    nextButtonText: 'Continue',
    backButtonText: 'Back',
    saveAndExitButtonText: 'Exit'
  },
  {
    name: Views.OME_MEET_ROSTER_SELECTION,
    subHeaderText: 'Roster Selection',
    instructionText: "Add or Remove Roster Athletes.",
    nextButtonText: 'Save',
    backButtonText: 'Back'
  },
  {
    name: Views.OME_MEET_ROSTER_ENTRIES_DETAIL,
    subHeaderText: 'Manage Athlete Events',
    instructionText: "Add or Remove Event Entries for the Selected Athlete.",
    backButtonText: 'Back'
  },
  {
    name: Views.OME_MEET_ROSTER_ENTRIES_INDIVIDUAL_SELECTION,
    subHeaderText: 'Individual Event Selection',
    instructionText: "Add or Remove Individual Event Entries for the Selected Athlete.",
    nextButtonText: 'Save',
    backButtonText: 'Back'
  },
  {
    name: Views.OME_MEET_ROSTER_ENTRIES_INDIVIDUAL_OVERRIDE,
    subHeaderText: 'Individual Event Entry Override Time',
    instructionText: "",
    nextButtonText: 'Save',
    backButtonText: 'Back'
  },
  {
    name: Views.OME_MEET_ROSTER_ENTRIES_BONUS_INDIVIDUAL_SELECTION,
    subHeaderText: 'Individual Bonus Event Selection',
    instructionText: "Add or Remove Individual Bonus Event Entries for the Selected Athlete.",
    nextButtonText: 'Save',
    backButtonText: 'Back'
  },
  {
    name: Views.OME_MEET_ROSTER_ENTRIES_BONUS_INDIVIDUAL_OVERRIDE,
    subHeaderText: 'Individual Bonus Event Entry Override Time',
    instructionText: "",
    nextButtonText: 'Save',
    backButtonText: 'Back'
  },
  {
    name: Views.OME_MEET_RELAY_ENTRIES,
    subHeaderText: 'Relay Entries',
    instructionText: 'Manage Relay Entries.',
    nextButtonText: 'Continue',
    backButtonText: 'Back',
    saveAndExitButtonText: 'Exit'
  },
  {
    name: Views.OME_MEET_MANAGE_RELAY_TEAMS,
    subHeaderText: 'Manage Relay Teams',
    instructionText: 'Add, Edit, or Delete Relay Teams.',
    backButtonText: 'Back'
  },
  {
    name: Views.OME_MEET_MANAGE_RELAY_TEAM,
    subHeaderText: 'Manage Relay Team',
    instructionText: 'Provide Relay Team Information.'
  },
  {
    name: Views.OME_MEET_MANAGE_RELAY_TEAM_OVERRIDE,
    subHeaderText: 'Add Relay Event Entry Override Time',
    instructionText: 'Provide Relay Team Override Information.',
    nextButtonText: 'Save',
    backButtonText: 'Back',
  },
  {
    name: Views.OME_MEET_CREDENTIALS,
    subHeaderText: 'Credentials',
    instructionText: "Add or Remove Credentials. The Number of Allowed Credentials is Determined by the Meet's Deck Pass Rules.",
    nextButtonText: 'Continue',
    backButtonText: 'Back',
    saveAndExitButtonText: 'Exit'
  },
  {
    name: Views.OME_MEET_CREDENTIALS_SELECTION,
    subHeaderText: 'Credentials Selection',
    instructionText: `Filter by a Credential. Then Select or Unselect Members to Assign to that Credential. Please Save Any Changes Before Filtering by a Different Credential or Clicking 'Clear Filter' - Unsaved Changes Will Not be Retained.`,
    nextButtonText: 'Save',
    backButtonText: 'Back',
  },
  {
    name: Views.OME_MEET_ENTRY_REPORTS,
    subHeaderText: 'Entry Reports',
    instructionText: 'Run Reports on the Team Entry.',
    nextButtonText: 'Continue',
    backButtonText: 'Back',
    saveAndExitButtonText: 'Exit'
  },
  {
    name: Views.OME_MEET_SUBMIT,
    subHeaderText: 'Submit',
    instructionText: 'Make Purchases and Submit the Team Entry.'
  },
  {
    name: Views.OME_MEET_SUBMITTED,
    subHeaderText: 'OME Team Entry is Submitted & Created',
    instructionText: 'Optional: Make Additional Purchases and Resubmit the Team Entry.'
  }
];

export const getViewData = (viewName) => {
  const view = VIEW_DATA.find(x => x.name === viewName);
  return { ...view };
};

export default Views;